// constants
import { NewsActionTypes } from "./constants";

export interface NewsActionType {
  type:
    | NewsActionTypes.API_RESPONSE_SUCCESS
    | NewsActionTypes.API_RESPONSE_ERROR
    | NewsActionTypes.CREATE_NEWS
    | NewsActionTypes.GET_NEWS
    | NewsActionTypes.UPDATE_NEWS
    | NewsActionTypes.DELETE_NEWS
    | NewsActionTypes.DELETE_IMAGE;
  payload: any;
}

interface newsDetails {
  id: string;
  title_en: string;
  title_ar: string;
  description_en: string;
  description_ar: string;
  images: File[] | null;
}

// common success
export const newsApiResponseSuccess = (
  actionType: string,
  data: newsDetails | {}
): NewsActionType => ({
  type: NewsActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const newsApiResponseError = (
  actionType: string,
  error: string
): NewsActionType => ({
  type: NewsActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const createNews = (
  title_en: string,
  title_ar: string,
  description_en: string,
  description_ar: string,
  coverimage: File,
  // images: File[] | null,
): NewsActionType => ({
  type: NewsActionTypes.CREATE_NEWS,
  payload: {
    title_en,
    title_ar,
    description_en,
    description_ar,
    // images,
    coverimage,
  },
});

export const getNews = (): NewsActionType => ({
  type: NewsActionTypes.GET_NEWS,
  payload: {},
});

export const deleteNews = (id: string): NewsActionType => ({
  type: NewsActionTypes.DELETE_NEWS,
  payload: { id },
});

export const deleteNewsImage = (
  ids: string[],
): NewsActionType => ({
  type: NewsActionTypes.DELETE_IMAGE,
  payload: { ids },
});

export const updateNews = (
  id: string,
  title_en: string,
  title_ar: string,
  description_ar: string,
  description_en: string,
  coverimage: File,
  // images: File[] | null,
): NewsActionType => ({
  type: NewsActionTypes.UPDATE_NEWS,
  payload: {
    id,
    title_en,
    title_ar,
    description_en,
    description_ar,
    // images,
    coverimage,
  },
});
